import { classNames } from '~/utils/classNames';

export const Table = ({ children, className }: { children: React.ReactNode; className?: string }) => {
  return (
    <div className={classNames('border rounded-lg border-bolt-ds-border-divider overflow-hidden', className)}>
      {children}
    </div>
  );
};

export const TableHead = ({ children, className }: { children: React.ReactNode; className?: string }) => {
  return (
    <div
      className={classNames(
        'relative bg-bolt-ds-surfaceOne h-11 text-xs text-bolt-ds-textTertiary flex items-center px-4 py-3 border-b border-bolt-ds-border-divider overflow-hidden',
        className,
      )}
    >
      {children}
    </div>
  );
};

export const TableRow = ({ children, className }: { children: React.ReactNode; className?: string }) => {
  return (
    <div
      className={classNames(
        'flex px-4 py-4 border-b border-bolt-ds-border-divider last:border-b-0 overflow-hidden',
        className,
      )}
    >
      {children}
    </div>
  );
};
